import { Popover, Tooltip } from '@mui/material'
import React, { useEffect, useRef } from 'react'
import { SubMenuIconWrapper, SubMenuWrapper, TextLink } from '../Styles/Styles'
import { FaGeneralSettingIcon, FaLegal } from '../../../Images/icon'
import useClickOutside from '../../../../hooks/useClickOutside/useClickOutside'
import { checkForSuperAdmin } from '../../../../core/utils'

const permission = JSON.parse(localStorage.getItem("permissions")) || [];

const generalSettings = permission.find((o) => o.slug === "general_settings");
const adsManagement = permission.find((o) => o.slug === "ads_management");
const scammerUserManagement = permission.find((o) => o.slug === "scammer_users_management");
const mobileVerison = permission.find((o) => o.slug === "mobile_verison");
const slideAccess = permission.find((o) => o.slug === "slide_management");
const faqAccess = permission.find((o) => o.slug === "faq");
const featuresAccess = permission.find((o) => o.slug === "features_management");
const roleAccess = permission.find((o) => o.slug === "role_management");
const commissionAccess = permission.find((o) => o.slug === "commission_management");


const SettingsSubMenu = () => {

    const isSuperAdmin = checkForSuperAdmin()

    const hasReadPermissionForSettingsManagement = generalSettings?.permissions?.find((o) => o.slug === "read")
    const hasReadPermissionForAdsManagement = adsManagement?.permissions?.find((o) => o.slug === "read")
    const hasReadPermissionForScammerManagement = scammerUserManagement?.permissions?.find((o) => o.slug === "read")
    const hasReadPermissionForVersioning = mobileVerison?.permissions?.find((o) => o.slug === "read")
    const hasReadPermissionForSlidesManagement = slideAccess?.permissions?.find((o) => o.slug === "read")
    const hasReadPermissionForFAQsManagement = faqAccess?.permissions?.find((o) => o.slug === "read")
    const hasReadPermissionForFeaturesManagement = featuresAccess?.permissions?.find((o) => o.slug === "read")
    const hasReadPermissionForRoleManagement = roleAccess?.permissions?.find((o) => o.slug === "read")
    const hasReadPermissionForCommissionManagement = commissionAccess?.permissions?.find((o) => o.slug === "read")

    const popoverRef = useRef(null);
    const isOutsideClicked = useClickOutside(popoverRef);

    const [anchorEl, setAnchorEl] = React.useState(null);

    useEffect(() => {
        if (isOutsideClicked) {
            handleClose();
        }
    }, [isOutsideClicked])

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    if (!isSuperAdmin &&
        !hasReadPermissionForSettingsManagement &&
        !hasReadPermissionForAdsManagement &&
        !hasReadPermissionForScammerManagement &&
        !hasReadPermissionForVersioning &&
        !hasReadPermissionForSlidesManagement &&
        !hasReadPermissionForFAQsManagement &&
        !hasReadPermissionForFeaturesManagement &&
        !hasReadPermissionForRoleManagement &&
        !hasReadPermissionForCommissionManagement) {
        return null
    }

    return (
        <>
            <Tooltip title='Settings' placement="right">
                <SubMenuIconWrapper
                    onClick={handleClick}
                >
                    <FaGeneralSettingIcon />
                </SubMenuIconWrapper>
            </Tooltip>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'center',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'center',
                    horizontal: 'left',
                }}
                ref={popoverRef}
            >
                <SubMenuWrapper>
                    {hasReadPermissionForSettingsManagement && <TextLink
                        to="/general-settings"
                        onClick={handleClose}
                    >
                        General settings
                    </TextLink>
                    }
                    {hasReadPermissionForAdsManagement &&
                        <TextLink
                            to="/ads-management"
                            onClick={handleClose}
                        >
                            Ads Management
                        </TextLink>
                    }
                    {hasReadPermissionForScammerManagement && (
                        <TextLink
                            to="/fraud-settings"
                            onClick={handleClose}
                        >
                            Fraud Settings
                        </TextLink>
                    )}
                    {/* Mobile Versions */}
                    {hasReadPermissionForVersioning && (
                        <TextLink
                            to="/mobile-versions"
                            onClick={handleClose}
                        >
                            Mobile Versions
                        </TextLink>
                    )}
                    {hasReadPermissionForSlidesManagement ? (
                        <TextLink
                            to="/slides/home-slider"
                            onClick={handleClose}
                        >
                            Home Slider
                        </TextLink>
                    ) : null}
                    {hasReadPermissionForFAQsManagement && (
                        <TextLink
                            to="/faqs"
                            onClick={handleClose}
                        >
                            FAQs
                        </TextLink>
                    )}
                    {hasReadPermissionForFeaturesManagement && (
                        <TextLink
                            to="/features"
                            onClick={handleClose}
                        >
                            Features
                        </TextLink>
                    )}
                    {hasReadPermissionForRoleManagement && (
                        <TextLink
                            to="/admin-roles-management"
                            onClick={handleClose}
                        >
                            Roles management
                        </TextLink>
                    )}
                    {hasReadPermissionForCommissionManagement && (
                        <TextLink
                            to="/commission"
                            onClick={handleClose}
                        >
                            Commission
                        </TextLink>
                    )}
                    {isSuperAdmin && (
                        <TextLink
                            to="/upload-translations"
                            onClick={handleClose}
                        >
                            Upload translations
                        </TextLink>
                    )}
                    {isSuperAdmin && (
                        <TextLink
                            to="/ota-updates"
                            onClick={handleClose}
                        >
                            OTA Updates
                        </TextLink>
                    )}
                </SubMenuWrapper>
            </Popover>
        </>
    )
}

export default SettingsSubMenu